import React from 'react';
import PropTypes from 'prop-types';
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import { inject, observer } from 'mobx-react';

@inject('appState')
@observer
export default class Example extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  static propTypes = {
    offset: PropTypes.number
  };
  static defaultProps = {
    offset: 0
  };
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    const { offset } = this.props;
    return (
      <Navbar
        fixed="top"
        inverse
        toggleable
        style={{ background: `rgba(0,0,0, ${offset / 100})` }}
        className="d-flex flex-row pr-1"
      >
        <NavbarBrand href="/">
          <img
            src="/assets/MLB-Main-Logo-Inverted.png"
            alt="Marylous' Boys Logo"
            height={100}
          />
        </NavbarBrand>
        <Nav className="ml-auto text-right">
          <NavItem>
            <NavLink href="/about" className="px-3">About</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/videos" className="px-3">Videos</NavLink>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Navigation.js